import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogisticZoneInput,
    LogisticZone,
    UpdateLogisticZoneInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class LogisticZoneService {
    private amplifyClient = generateClient();
    constructor() {}

    async getLogisticZone(id: string): Promise<LogisticZone> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getLogisticZone,
                    variables: {
                        id
                    }
                })
            ).data.getLogisticZone;
            if (data) return data as LogisticZone;
        } catch (error) {
            console.error('Error finding LogisticZone:', error);
            return null;
        }
    }

    async listLogisticZones(): Promise<LogisticZone[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogisticZones
                })
            ).data.listLogisticZones.items;
            if (data) return data as LogisticZone[];
        } catch (error) {
            console.error('Error finding LogisticZone:', error);
            return null;
        }
    }

    async listAllLogisticZones(
        pageLimit: number = 100
    ): Promise<LogisticZone[]> {
        const zones: LogisticZone[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listLogisticZones,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listLogisticZones;
                zones.push(...((response?.items ?? []) as LogisticZone[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return zones;
        } catch (error) {
            console.error('Error finding LogisticZone:', error);
            return [];
        }
    }

    async createLogisticZone(
        input: CreateLogisticZoneInput
    ): Promise<LogisticZone> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogisticZone,
                    variables: {
                        input
                    }
                })
            ).data.createLogisticZone;
            if (date) return date as LogisticZone;
        } catch (error) {
            console.error('Error creating LogisticZone:', error);
            return null;
        }
    }

    async updateLogisticZone(
        input: UpdateLogisticZoneInput
    ): Promise<LogisticZone> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogisticZone,
                    variables: {
                        input
                    }
                })
            ).data.updateLogisticZone;
            if (date) return date as LogisticZone;
        } catch (error) {
            console.error('Error creating LogisticZone:', error);
            return null;
        }
    }
}
